import { format } from "date-fns";

import { getOffsetDate } from "fe-shared/src/helpers/dates";

const formatDate = (dateString: string) =>
  format(getOffsetDate(new Date(dateString || Date.now()))!, "MMM d, yyyy");

// Same grouping the transaction number gets - the portal shows the two side by side.
export const formatRequestNumber = (requestNumber = "", prefix = "#") =>
  `${prefix}${[
    requestNumber.slice(0, 3),
    requestNumber.slice(3, 6),
    requestNumber.slice(6),
  ]
    .filter(Boolean)
    .join(" ")}`;

export const getFormattedDateRange = (fromDate = "", toDate = "") => {
  const fromDateDay = fromDate.slice(0, 10);
  const toDateDay = toDate?.slice(0, 10);

  return `${formatDate(fromDateDay)}${
    toDateDay && toDateDay !== fromDateDay ? ` - ${formatDate(toDateDay)}` : ""
  }`;
};
